import { Injectable, inject } from '@angular/core';
import { CanActivate, CanActivateFn, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(): boolean {
    const isLoggedIn = !!sessionStorage.getItem('token'); // or use auth service

    if (isLoggedIn) {
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}

export const configurationGuard: CanActivateFn = () => {
  const router = inject(Router);
  const userRole = Number(sessionStorage.getItem('role'));
  if (userRole === 99) {
    return true;
  }
  return router.createUrlTree(['/unauthorized-access']);
};